// extracted by mini-css-extract-plugin
export var blue = "_1m-g";
export var brand = "_1m-c";
export var darkGrey = "_1m-f";
export var disabled = "_1m-6";
export var disabledSubtle = "_1m-7";
export var error = "_1m-8";
export var green = "_1m-h";
export var grey = "_1m-e";
export var icon = "_1m-0";
export var inherit = "_1m-b";
export var lightGrey = "_1m-d";
export var orange = "_1m-j";
export var pink = "_1m-l";
export var primary = "_1m-1";
export var purple = "_1m-m";
export var quaternary = "_1m-4";
export var quinary = "_1m-5";
export var red = "_1m-k";
export var secondary = "_1m-2";
export var success = "_1m-a";
export var tertiary = "_1m-3";
export var warning = "_1m-9";
export var white = "_1m-n";
export var yellow = "_1m-i";